export default __webpack_public_path__ + "img/GetItOnGooglePlay_Badge_Web_color_English.86d7c822.png";